// @ts-ignore
import React from 'react';
import { composer } from "../../../../../component-decorators/composer";
import { Box, Button, Divider, Modal, ModalMobileLayout, Text, TextButton } from "wix-style-react";
// @ts-ignore
import s from './other-countries.scss';
export var OtherCountriesModal = composer()
    .withTranslation()
    .compose(function (_a) {
    var subtitle = _a.subtitle, closeModal = _a.closeModal, countries = _a.countries, footerTwo = _a.footerTwo, t = _a.t, onSupportClick = _a.onSupportClick;
    return (React.createElement(Modal, { isOpen: true, zIndex: 100000 },
        React.createElement(ModalMobileLayout, { stickyTitle: true, stickyFooter: true, fullscreen: true, title: React.createElement(Text, { className: s.otherCountriesTitle, weight: "bold" }, t('solution.page.tagsBoxAvailabilityTitle')), content: React.createElement(Box, { direction: "vertical" },
                React.createElement(Text, { size: "small", weight: "bold", className: s.countryListSubtitle }, subtitle),
                countries.map(function (country) { return (
                // tslint:disable-next-line:jsx-key
                React.createElement(Text, { size: "small", weight: "thin", className: s.countryList },
                    "- \u00A0",
                    country)); }),
                React.createElement(Divider, null),
                React.createElement(Box, { direction: "horizontal", marginTop: "18px", verticalAlign: "middle" },
                    React.createElement(Text, { size: 'tiny' }, t('solution.page.tagsBoxAvailabilityPopoverFooter1')),
                    React.createElement(TextButton, { as: "a", size: 'tiny', onClick: onSupportClick },
                        "\u00A0",
                        footerTwo))), footer: React.createElement(Box, { align: "right", marginTop: "16px" },
                React.createElement(Box, { marginRight: "12px" },
                    React.createElement(Button, { onClick: closeModal, priority: "secondary" }, t('solution.page.tagsBoxAvailabilitySecondaryCta'))),
                React.createElement(Button, { onClick: closeModal }, t('solution.page.tagsBoxAvailabilityCta'))), onCloseButtonClick: closeModal })));
});
//# sourceMappingURL=other-countries-modal.js.map